/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JobExecutionOutputDetails {
    getFixupPrototypeFunction() { return JobExecutionOutputDetails.fixupPrototype; }

    static newInstance(model: Partial<JobExecutionOutputDetails>): JobExecutionOutputDetails {
        let obj = Object.assign(new JobExecutionOutputDetails(), model);
        JobExecutionOutputDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JobExecutionOutputDetails>): JobExecutionOutputDetails {
        if (!model) return null;
        return JobExecutionOutputDetails.newInstance(<JobExecutionOutputDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JobExecutionOutputDetails) {
        if (!obj) return;

        models.JobExecutionOutputDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JobExecutionOutputDetails): boolean {
        Object.setPrototypeOf(obj, JobExecutionOutputDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource Id
     */
    resource_id: string;

    /**
     * Resource Name
     */
    resource_name: string;

    /**
     * Resource Category
     */
    category: string;

    /**
     * Resource Type
     */
    resource_type: string;

    /**
     * Resource
     */
    resource: string;

    /**
     * Location
     */
    location: string;

    /**
     * Evidence
     */
    evidence: string;

    /**
     * Dynamic map of rule-specific output attribute names to values
     */
    additional_attributes: { [key: string]: string; };

}
